import{defineMessages}from"react-intl";export var messages=defineMessages({actionsLabel:{id:"jutro-quick-view.actionsLabel",defaultMessage:"Actions"}});